import { Loader2 } from "lucide-react";

// Suspense fallback shown while a lazy-loaded route chunk downloads.
const RouteLoading = () => (
  <div className="flex h-full min-h-[40vh] w-full items-center justify-center">
    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
  </div>
);

export default RouteLoading;
